import { render, staticRenderFns } from "./MassAdjustTags.vue?vue&type=template&id=77235223&scoped=true"
import script from "./MassAdjustTags.vue?vue&type=script&lang=js"
export * from "./MassAdjustTags.vue?vue&type=script&lang=js"
import style0 from "./MassAdjustTags.vue?vue&type=style&index=0&id=77235223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77235223",
  null
  
)

export default component.exports